import React, { Component } from 'react';
import Clock from 'react-clock';
import DeviceData from 'drivers/deviceData';
import { Navigate } from 'react-router-dom';
import Route from 'enum/route.enum';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';
import DeafultTimeZone from 'components/time/defaultTimeZone';
import { Container, ContainerModal, RowContainer } from 'components/styles/Common.styled';
import { TimeDisplayContainer, CityName, ClockContainer } from 'components/styles/Time.styled';

import EventBus from 'utils/eventBus';
import BackCursor from 'components/common/nav/backCursor';
import { translate as t } from 'utils/i18n';
import { getDateInTimeZone, resolveLocationTimeZone } from '../main/common/utils';

class time extends Component {
  constructor(props) {
    super(props);
    this.subscriptions = {};
    this.state = {
      date: new Date(),
      redirectBack: false,
      locations: [],
      dateTime: {},
    };
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  async componentDidMount() {
    this.subscriptions = EventBus.subscribe('refresh', this.getData.bind(this));
    this.getData();
    window.addEventListener('keydown', this.onKeyPress);
  }
  componentWillUnmount() {
    this.subscriptions.unsubscribe();
    clearInterval(this.interval);
    window.removeEventListener('keydown', this.onKeyPress);
  }

  async getData() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    const city = Storages.MainStorage.getItem(StorageKeys.Keys.CURRENTLOCATION);
    const locationData = [];

    if (city) {
      locationData.push({
        name: city.city_name || '',
        timezone: resolveLocationTimeZone(city),
      });
    }

    locationData.push({
      name: t('Time.london'),
      timezone: DeafultTimeZone.london,
    });

    locationData.push({
      name: t('Time.new_york'),
      timezone: DeafultTimeZone.new_york,
    });

    this.setState(
      {
        locations: locationData,
      },
      () => {
        this.getTimeForCities();
        // Tick every second so the second hand moves
        this.interval = setInterval(() => {
          this.getTimeForCities();
        }, 1000);
      }
    );
  }

  async getTimeForCities() {
    try {
      const { locations } = this.state;
      const dateTime = {};
      const estTime = new Date();

      for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        const timezone = location?.timezone || DeafultTimeZone.new_york;
        const cityTime = getDateInTimeZone(estTime, timezone);

        dateTime[`city${i + 1}`] = {
          name: location?.name || '',
          dateTime: cityTime,
          timezone: timezone,
        };
      }

      this.setState({
        dateTime,
      });
    } catch (err) {
      console.warn('Time page getTimeForCities failed:', err && err.message);
    }
  }

  async onKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();

    switch (event.keyCode) {
      case tvKeyControls.KEY_BACK:
        this.setState({
          redirectBack: true,
        });
        event.preventDefault();
        break;

      default:
        break;
    }
  }

  render() {
    const { dateTime } = this.state;
    if (this.state.redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }
    return (
      <div>
        <>
          <BackCursor></BackCursor>
          <Container>
            <ContainerModal>
              <RowContainer>
                {Object.entries(dateTime).map(
                  ([key, city]) =>
                    city.name &&
                    city.dateTime &&
                    !isNaN(city.dateTime.getTime()) && (
                      <TimeDisplayContainer key={key}>
                        <CityName>{city.name}</CityName>
                        <ClockContainer>
                          <Clock
                            className=''
                            value={city.dateTime}
                            renderSecondHand={true}
                            secondHandLength={90}
                            secondHandWidth={2}
                          />
                        </ClockContainer>
                      </TimeDisplayContainer>
                    )
                )}
              </RowContainer>
            </ContainerModal>
          </Container>
        </>
      </div>
    );
  }
}

export default time;
